<section class="learning" style="margin-top: 0;">
    <div class="wrapper" *ngIf="isData">

        <learning-intro></learning-intro>

        <div class="container-fluid">
            <div class="row">


                <div class="col-md-4" *ngFor="let lesson of lessons">
                    <a routerLink="/posts/viewpost/{{lesson.name}}">
                        <div 
                        class="card" 
                        style="margin-bottom: 25px; box-shadow: 0 5px 1px 0px var(--sec-color); cursor: pointer;" 
                        matRipple>
                            
                        <div class="card-img-box">
                            <img 
                                src="https://www.admin.codesroots.com//library/codesroots/photo/umphotos/{{lesson.photo}}" 
                                alt="Card image cap"
                                class="w-100 h-100"
                            >
                        </div>

                            <div class="card-body text-center">
                              <h5 class="card-title" style="color: #0c2f69; font-size: 20px;">{{lesson.catheads}}</h5>
                            </div>
                        
                        </div> 
                    </a>                   
                </div>


            </div>
        </div>

    </div> 
    
    <app-loader [loader]='isLoading'></app-loader>

</section>